type RulesObject = {
  [key: string]:
    | {
        value: string | boolean | number | RegExp;
        message: string;
      }
    | number
    | boolean;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createRulesObject = (fieldSpec: any) => {
  const rules: RulesObject = {};
  if (fieldSpec.constraints?.required) {
    rules.required = {
      value: typeof fieldSpec.constraints.required === 'string' ? Boolean(fieldSpec.constraints.required) : true,
      message: `${fieldSpec.label} is required`,
    };
  }
  ['min', 'max', 'minLength', 'maxLength'].forEach(constraint => {
    if (fieldSpec.constraints?.[constraint] !== undefined) {
      rules[constraint] = {
        value:
          typeof fieldSpec.constraints[constraint] === 'string'
            ? Number(fieldSpec.constraints[constraint])
            : fieldSpec.constraints[constraint],
        message: `${constraint.charAt(0).toUpperCase() + constraint.slice(1)} value is ${
          fieldSpec.constraints[constraint]
        }`,
      };
    }
  });
  if (fieldSpec.constraints?.pattern) {
    rules.pattern = {
      value:
        typeof fieldSpec.constraints.pattern === 'string'
          ? new RegExp(fieldSpec.constraints.pattern)
          : fieldSpec.constraints.pattern,
      message: `Invalid format`,
    };
  }

  if (fieldSpec.constraints?.valueAsDate) {
    rules.valueAsDate = true;
  }
  if (fieldSpec.constraints?.valueAsNumber) {
    rules.valueAsNumber = true;
  }
  if (fieldSpec.constraints?.disabled) {
    rules.disabled = true;
  }

  return rules;
};

export default createRulesObject;
